const appointmentRequests = {
  mainDays: null,
  mainTimes: null,
  guaranteeDays: null,
  guaranteeTimes: null
};

const SELECTORS = {
  service: "select#service_hand, select#service_feet",
  day: "select#day_options",
  time: "select#time_options",
  guaranteeService: "select#guarantee_service",
  guaranteeDay: "select#service_day_options",
  guaranteeTime: "select#service_time_options"
};

const MESSAGES = {
  daysError: "Kon de beschikbare dagen niet laden",
  timesError: "Kon de beschikbare tijden niet laden",
  chooseService: "Selecteer eerst een behandeling",
  chooseDay: "Selecteer eerst een dag"
};

function getSelect(id) {
  return document.getElementById(id);
}

function getWrap(select) {
  return select ? select.closest(".select-wrap") : null;
}

function updateEveningSurchargeNotice() {
  const notice = document.getElementById("evening-surcharge-notice");
  const noticeText = notice ? notice.querySelector("[data-evening-surcharge-text]") : null;
  const timeSelect = getSelect("time_options");

  if (!notice || !noticeText) return;

  const selectedOption = timeSelect && timeSelect.selectedIndex >= 0
    ? timeSelect.options[timeSelect.selectedIndex]
    : null;
  const message = selectedOption && selectedOption.dataset.evening === "true"
    ? selectedOption.dataset.eveningMessage
    : "";

  noticeText.textContent = message || "";
  notice.hidden = !message;
}

function setWrapLoading(select, state) {
  const wrap = getWrap(select);
  if (!wrap) return;
  wrap.classList.toggle("is-loading", state);
  wrap.setAttribute("aria-busy", state ? "true" : "false");
}

function setPlaceholderOption(select, text) {
  if (!select) return;
  select.innerHTML = "";
  const option = document.createElement("option");
  option.textContent = text;
  option.value = "";
  option.disabled = true;
  option.selected = true;
  option.setAttribute("data-placeholder", "true");
  select.appendChild(option);
}

function setLoadingState(select) {
  if (!select) return;
  setWrapLoading(select, true);
  select.disabled = true;
  select.setAttribute("aria-disabled", "true");
  select.setAttribute("aria-busy", "true");
}

function setPendingState(select, message) {
  if (!select) return;
  setWrapLoading(select, false);
  select.disabled = true;
  select.setAttribute("aria-disabled", "true");
  select.removeAttribute("aria-busy");
  select.removeAttribute("aria-invalid");
  setPlaceholderOption(select, message);
}

function clearLoadingState(select) {
  if (!select) return;
  setWrapLoading(select, false);
  select.disabled = false;
  select.removeAttribute("aria-disabled");
  select.removeAttribute("aria-busy");
  select.removeAttribute("aria-invalid");
}

function setErrorState(select, message) {
  if (!select) return;
  setWrapLoading(select, false);
  select.disabled = false;
  select.setAttribute("aria-invalid", "true");
  select.removeAttribute("aria-busy");
  setPlaceholderOption(select, message);
}

function parseResponse(html) {
  const parser = new DOMParser();
  return parser.parseFromString(html, "text/html");
}

function syncSelectOptions(target, source) {
  if (!target || !source) return;
  target.innerHTML = source.innerHTML;
}

function updateMainDaySectionFromResponse(doc) {
  const responseDaySelect = doc.querySelector("#day_options");
  const responseTimeSelect = doc.querySelector("#time_options");
  const responseFullyBooked = doc.querySelector("#fully_booked");

  const daySelect = getSelect("day_options");
  const timeSelect = getSelect("time_options");
  const fullyBooked = document.getElementById("fully_booked");

  syncSelectOptions(daySelect, responseDaySelect);
  syncSelectOptions(timeSelect, responseTimeSelect);

  if (fullyBooked && responseFullyBooked) {
    fullyBooked.innerHTML = responseFullyBooked.innerHTML;
    if (responseFullyBooked.classList.contains("show")) {
      $("#fully_booked").collapse("show");
    } else {
      $("#fully_booked").collapse("hide");
    }
  } else {
    $("#fully_booked").collapse("hide");
  }
}

function updateMainTimeSectionFromResponse(doc) {
  const responseTimeSelect = doc.querySelector("#time_options");
  const responseFullyBooked = doc.querySelector("#fully_booked");

  const timeSelect = getSelect("time_options");
  const fullyBooked = document.getElementById("fully_booked");

  syncSelectOptions(timeSelect, responseTimeSelect);

  if (fullyBooked && responseFullyBooked) {
    fullyBooked.innerHTML = responseFullyBooked.innerHTML;
  }
}

function updateGuaranteeDaySectionFromResponse(doc) {
  const responseDaySelect = doc.querySelector("#service_day_options");
  const responseTimeSelect = doc.querySelector("#service_time_options");

  const daySelect = getSelect("service_day_options");
  const timeSelect = getSelect("service_time_options");

  syncSelectOptions(daySelect, responseDaySelect);
  syncSelectOptions(timeSelect, responseTimeSelect);
}

function updateGuaranteeTimeSectionFromResponse(doc) {
  const responseTimeSelect = doc.querySelector("#service_time_options");
  const timeSelect = getSelect("service_time_options");
  syncSelectOptions(timeSelect, responseTimeSelect);
}

function abortRequest(key) {
  if (appointmentRequests[key]) {
    appointmentRequests[key].abort();
    appointmentRequests[key] = null;
  }
}

function initializeAppointmentState() {
  const daySelect = getSelect("day_options");
  const timeSelect = getSelect("time_options");
  const handSelect = getSelect("service_hand");
  const feetSelect = getSelect("service_feet");
  const handValue = handSelect ? handSelect.value : "";
  const feetValue = feetSelect ? feetSelect.value : "";

  if (daySelect) {
    const hasDayOptions = Array.prototype.some.call(daySelect.options || [], (option) => option.value !== "");
    if (!handValue && !feetValue && !hasDayOptions) {
      setPendingState(daySelect, MESSAGES.chooseService);
    } else {
      clearLoadingState(daySelect);
    }
  }

  if (timeSelect) {
    if (!timeSelect.options.length || timeSelect.options.length === 1 && timeSelect.options[0].value === "") {
      setPendingState(timeSelect, MESSAGES.chooseDay);
    } else {
      clearLoadingState(timeSelect);
    }
  }

  updateEveningSurchargeNotice();

  const guaranteeDaySelect = getSelect("service_day_options");
  const guaranteeTimeSelect = getSelect("service_time_options");
  const guaranteeServiceSelect = getSelect("guarantee_service");
  const guaranteeServiceValue = guaranteeServiceSelect ? guaranteeServiceSelect.value : "";

  if (guaranteeTimeSelect) {
    if (!guaranteeTimeSelect.options.length || guaranteeTimeSelect.options.length === 1 && guaranteeTimeSelect.options[0].value === "") {
      setPendingState(guaranteeTimeSelect, MESSAGES.chooseDay);
    } else {
      clearLoadingState(guaranteeTimeSelect);
    }
  }

  if (guaranteeDaySelect) {
    const hasOptions = Array.prototype.some.call(guaranteeDaySelect.options || [], (option) => option.value !== "");
    if (!guaranteeServiceValue && !hasOptions) {
      setPendingState(guaranteeDaySelect, MESSAGES.chooseService);
    } else {
      clearLoadingState(guaranteeDaySelect);
    }
  }
}

function toggleGuaranteeInfo() {
  const handSelect = getSelect("service_hand");
  const feetSelect = getSelect("service_feet");

  const handIndex = handSelect ? handSelect.selectedIndex : -1;
  const feetIndex = feetSelect ? feetSelect.selectedIndex : -1;
  const handText = handSelect && handIndex >= 0 ? handSelect.options[handIndex].text : "";
  const feetText = feetSelect && feetIndex >= 0 ? feetSelect.options[feetIndex].text : "";

  if (handText.includes("Garantie") || feetText.includes("Garantie")) {
    $("#guarantee_info").collapse("show");
  } else {
    $("#guarantee_info").collapse("hide");
  }
}

function handleMainServiceChange() {
  const handSelect = getSelect("service_hand");
  const feetSelect = getSelect("service_feet");
  const daySelect = getSelect("day_options");
  const timeSelect = getSelect("time_options");

  if (!daySelect || !timeSelect) return;

  const handValue = handSelect ? handSelect.value : "";
  const feetValue = feetSelect ? feetSelect.value : "";
  const selectedService = `${handValue},${feetValue}`;

  toggleGuaranteeInfo();
  $("#fully_booked").collapse("hide");
  updateEveningSurchargeNotice();

  if (!handValue && !feetValue) {
    setPendingState(daySelect, MESSAGES.chooseService);
    setPendingState(timeSelect, MESSAGES.chooseService);
    updateEveningSurchargeNotice();
    return;
  }

  setLoadingState(daySelect);
  setPendingState(timeSelect, MESSAGES.chooseDay);
  updateEveningSurchargeNotice();

  abortRequest("mainDays");

  appointmentRequests.mainDays = $.ajax({
    url: `/mynails/appointment/${selectedService}/none/new`,
    method: "GET",
    dataType: "html"
  })
    .done((response) => {
      const doc = parseResponse(response);
      updateMainDaySectionFromResponse(doc);
      clearLoadingState(daySelect);
      const updatedTimeSelect = getSelect("time_options");
      setPendingState(updatedTimeSelect, MESSAGES.chooseDay);
    })
    .fail((_xhr, status) => {
      if (status === "abort") return;
      setErrorState(daySelect, MESSAGES.daysError);
      setPendingState(timeSelect, MESSAGES.chooseDay);
    })
    .always(() => {
      appointmentRequests.mainDays = null;
    });
}

function handleMainDayChange(selectedDay) {
  const handSelect = getSelect("service_hand");
  const feetSelect = getSelect("service_feet");
  const timeSelect = getSelect("time_options");

  if (!timeSelect) return;

  const handValue = handSelect ? handSelect.value : "";
  const feetValue = feetSelect ? feetSelect.value : "";

  if (!selectedDay) {
    abortRequest("mainTimes");
    setPendingState(timeSelect, MESSAGES.chooseDay);
    $("#fully_booked").collapse("hide");
    updateEveningSurchargeNotice();
    return;
  }

  if (!handValue && !feetValue) {
    setPendingState(timeSelect, MESSAGES.chooseService);
    return;
  }

  setLoadingState(timeSelect);
  updateEveningSurchargeNotice();

  abortRequest("mainTimes");

  appointmentRequests.mainTimes = $.ajax({
    url: `/mynails/appointment/${handValue},${feetValue}/${selectedDay}/new`,
    method: "GET",
    dataType: "html"
  })
    .done((response) => {
      const doc = parseResponse(response);
      updateMainTimeSectionFromResponse(doc);
      const updatedTimeSelect = getSelect("time_options");
      clearLoadingState(updatedTimeSelect);
      updateEveningSurchargeNotice();
      const timeOptions = $("#time_options option");
      if (timeOptions.length === 1) {
        const daySelect = getSelect("day_options");
        const dateString = daySelect ? daySelect.value : "";
        if (dateString) {
          const parsed = new Date(parseInt(dateString.substring(0, 4), 10), parseInt(dateString.substring(5, 7), 10) - 1, parseInt(dateString.substring(8, 10), 10));
          const fullyBookedDay = document.getElementById("fully_booked_day");
          if (fullyBookedDay) {
            fullyBookedDay.innerHTML = new Intl.DateTimeFormat("nl-NL", { month: "long", day: "numeric" }).format(parsed);
          }
        }
        $("#fully_booked").collapse("show");
      } else {
        $("#fully_booked").collapse("hide");
      }

      const selectedIndex = daySelect ? daySelect.selectedIndex : -1;
      const dayOption = daySelect && selectedIndex >= 0 ? daySelect.options[selectedIndex] : null;
      if (dayOption) {
        const dayText = dayOption.text || "";
        const feetSelect = getSelect("service_feet");
        const feetIdx = feetSelect ? feetSelect.selectedIndex : -1;
        const feetText = feetSelect && feetIdx >= 0 ? feetSelect.options[feetIdx].text : "";
        if ((dayText.includes("woensdag") || dayText.includes("donderdag")) && feetText.includes("pedicure")) {
          $("#latte-heart-action").collapse("show");
        } else {
          $("#latte-heart-action").collapse("hide");
          const serviceAddon = document.getElementById("service_addon");
          if (serviceAddon) serviceAddon.value = 0;
        }
      }
    })
    .fail((_xhr, status) => {
      if (status === "abort") return;
      setErrorState(timeSelect, MESSAGES.timesError);
      $("#fully_booked").collapse("hide");
    })
    .always(() => {
      appointmentRequests.mainTimes = null;
    });
}

function handleGuaranteeServiceChange() {
  const serviceSelect = getSelect("guarantee_service");
  const daySelect = getSelect("service_day_options");
  const timeSelect = getSelect("service_time_options");

  if (!serviceSelect || !daySelect || !timeSelect) return;

  const selectedService = serviceSelect.value;

  if (!selectedService) {
    setPendingState(daySelect, MESSAGES.chooseService);
    setPendingState(timeSelect, MESSAGES.chooseService);
    return;
  }

  setLoadingState(daySelect);
  setPendingState(timeSelect, MESSAGES.chooseDay);

  abortRequest("guaranteeDays");

  appointmentRequests.guaranteeDays = $.ajax({
    url: `/mynails/appointment/${selectedService}/none/new`,
    method: "GET",
    dataType: "html"
  })
    .done((response) => {
      const doc = parseResponse(response);
      updateGuaranteeDaySectionFromResponse(doc);
      const updatedDaySelect = getSelect("service_day_options");
      clearLoadingState(updatedDaySelect);
      const updatedTimeSelect = getSelect("service_time_options");
      setPendingState(updatedTimeSelect, MESSAGES.chooseDay);
    })
    .fail((_xhr, status) => {
      if (status === "abort") return;
      setErrorState(daySelect, MESSAGES.daysError);
      setPendingState(timeSelect, MESSAGES.chooseDay);
    })
    .always(() => {
      appointmentRequests.guaranteeDays = null;
    });
}

function handleGuaranteeDayChange(selectedDay) {
  const serviceSelect = getSelect("guarantee_service");
  const timeSelect = getSelect("service_time_options");

  if (!serviceSelect || !timeSelect) return;

  if (!serviceSelect.value) {
    setPendingState(timeSelect, MESSAGES.chooseService);
    return;
  }

  if (!selectedDay) {
    abortRequest("guaranteeTimes");
    setPendingState(timeSelect, MESSAGES.chooseDay);
    return;
  }

  setLoadingState(timeSelect);

  abortRequest("guaranteeTimes");

  appointmentRequests.guaranteeTimes = $.ajax({
    url: `/mynails/appointment/${serviceSelect.value}/${selectedDay}/new`,
    method: "GET",
    dataType: "html"
  })
    .done((response) => {
      const doc = parseResponse(response);
      updateGuaranteeTimeSectionFromResponse(doc);
      const updatedTimeSelect = getSelect("service_time_options");
      clearLoadingState(updatedTimeSelect);
    })
    .fail((_xhr, status) => {
      if (status === "abort") return;
      setErrorState(timeSelect, MESSAGES.timesError);
    })
    .always(() => {
      appointmentRequests.guaranteeTimes = null;
    });
}

function handleChange(event) {
  if (!event.target || event.target.tagName !== "SELECT") return;

  if (event.target.matches(SELECTORS.service)) {
    handleMainServiceChange();
  } else if (event.target.matches(SELECTORS.day)) {
    handleMainDayChange(event.target.value);
  } else if (event.target.matches(SELECTORS.time)) {
    updateEveningSurchargeNotice();
  } else if (event.target.matches(SELECTORS.guaranteeService)) {
    handleGuaranteeServiceChange();
  } else if (event.target.matches(SELECTORS.guaranteeDay)) {
    handleGuaranteeDayChange(event.target.value);
  }
}

function setupEventListeners() {
  if (window._appointmentSelectHandlersAttached) return;

  document.addEventListener("change", handleChange);
  if (!window._appointmentBeforeCacheHandler) {
    window._appointmentBeforeCacheHandler = () => {
      document.removeEventListener("change", handleChange);
      window._appointmentSelectHandlersAttached = false;
    };
    window.addEventListener("turbolinks:before-cache", window._appointmentBeforeCacheHandler);
  }

  window._appointmentSelectHandlersAttached = true;
}

window.addEventListener("turbolinks:load", () => {
  setupEventListeners();
  initializeAppointmentState();
});

document.addEventListener("appointment:content-updated", () => {
  initializeAppointmentState();
});
